export const routeIcons = [
  { route: "dashboard", icon: "assets/img/dashbord/icon/dashbord.png", subroute: [] },
  { route: "user", icon: "assets/img/dashbord/icon/rework.png", subroute: [] },
  { route: "userapplication", icon: "assets/img/dashbord/icon/rework.png", subroute: [] },
  { route: "configuration", icon: "assets/img/dashbord/icon/knowledge.png", subroute: [] },
  { route: "reports", icon: "assets/img/dashbord/icon/knowledge.png", subroute: [] },
  { route: "settings", icon: "assets/img/dashbord/icon/knowledge.png", subroute: [] },
  { route: "recipe", icon: "assets/img/dashbord/icon/recipe.png", subroute: [] },
  { route: "addrecipe", icon: "assets/img/dashbord/icon/recipe.png", subroute: [] },
  { route: "billing", icon: "assets/img/dashbord/icon/billing.png", subroute: [] },
  { route: "finishproduct", icon: "assets/img/dashbord/icon/rework.png", subroute: [] },
  {
    route: "ingredients", icon: "assets/img/dashbord/icon/ingredient.png",
    subroute: [
      { route: "rawingredient", icon: "ft-arrow-right submenu-icon" },
      { route: "add", icon: "ft-arrow-right submenu-icon" },
    ]
  },
  {
    route: "supplement",
    icon: "assets/img/dashbord/icon/rework.png",
    subroute: [
      { route: "supplement/add", icon: "ft-minus submenu-icon" },

      {
        route: "superadmin",
        icon: "ft-arrow-right submenu-icon",
        subroute: [
          { route: "supplement/superadmin/dashbord", icon: "ft-minus submenu-icon" },
          { route: "supplement/superadmin/all", icon: "ft-minus submenu-icon" },
          { route: "supplement/superadmin/billing", icon: "ft-minus submenu-icon" }
        ]
      },

      {
        route: "checker",
        icon: "ft-arrow-right submenu-icon",
        subroute: [
          { route: "supplement/checker/dashbord", icon: "ft-minus submenu-icon" },
          { route: "supplement/checker/supplements", icon: "ft-minus submenu-icon" },
          { route: "supplement/checker/billing", icon: "ft-minus submenu-icon" }
        ]
      },

      {
        route: "maker",
        icon: "ft-arrow-right submenu-icon",
        subroute: [
          { route: "supplement/maker/dashbord", icon: "ft-minus submenu-icon" },
          { route: "supplement/maker/recipelist", icon: "ft-minus submenu-icon" },
          { route: "supplement/maker/billing", icon: "ft-minus submenu-icon" }
        ]
      }
    ]
  },
  { route: "reeWorkrecipes", icon: "assets/img/dashbord/icon/reecoach.png", subroute: [] },
  { route: "recipe", icon: "assets/img/dashbord/icon/recipe.png", subroute: [] },
  { route: "billing", icon: "assets/img/dashbord/icon/billing.png", subroute: [] },
  { route: "knowledgebank", icon: "assets/img/dashbord/icon/knowledge.png", subroute: [] },
  { route: "finishedProduct", icon: "assets/img/dashbord/icon/reecoach.png", subroute: [] },
  // { route: "supplement", icon: "assets/img/dashbord/icon/reecoach.png", subroute: [] },
  { route: "addrecipe", icon: "assets/img/dashbord/icon/reecoach.png", subroute: [] },
  { route: "viewrecipe", icon: "assets/img/dashbord/icon/reecoach.png", subroute: [] },

  { route: "reecoachrecipes", icon: "assets/img/dashbord/icon/reecoach.png", subroute: [] },
  { route: "notification", icon: "assets/img/dashbord/icon/knowledge.png", subroute: [] },

  // finish-product
  {
    route: "finishproduct", icon: "assets/img/dashbord/icon/rework.png",
    subroute: [
      { route: "finishproduct/addfinishedproduct", icon: "ft-minus submenu-icon" },

      {
        route: "superadmin",
        icon: "ft-arrow-right submenu-icon",
        subroute: [
          { route: "super-admin-dashbord", icon: "ft-minus submenu-icon" },
          { route: "super-admin-finish-product", icon: "ft-minus submenu-icon" },
          { route: "super-admin-billing", icon: "ft-minus submenu-icon" }
        ]
      },

      {
        route: "checker",
        icon: "ft-arrow-right submenu-icon",
        subroute: [
          { route: "checker-dashbord", icon: "ft-minus submenu-icon" },
          { route: "checker-finish-product", icon: "ft-minus submenu-icon" },
          { route: "checker-billing", icon: "ft-minus submenu-icon" }
        ]
      },

      {
        route: "maker",
        icon: "ft-arrow-right submenu-icon",
        subroute: [
          { route: "finish-maker-dashbord", icon: "ft-minus submenu-icon" },
          { route: "maker-finish-product", icon: "ft-minus submenu-icon" },
          { route: "maker-billing", icon: "ft-minus submenu-icon" }
        ]
      }
    ]
  },

  {
    route: "master", icon: "assets/img/dashbord/icon/knowledge.png", subroute: [
      { route: "allergen", icon: "ft-arrow-right submenu-icon" },
      { route: "aroma", icon: "ft-arrow-right submenu-icon" },
      { route: "authorized-certificate-master", icon: "ft-arrow-right submenu-icon" },
      { route: "supplement-authorized-label-master", icon: "ft-arrow-right submenu-icon" },
      { route: "supplement-ingredient-master", icon: "ft-arrow-right submenu-icon" },
      { route: "authorized-license-master", icon: "ft-arrow-right submenu-icon" },
      { route: "claims-master", icon: "ft-arrow-right submenu-icon" },
      { route: "cookingprocess", icon: "ft-arrow-right submenu-icon" },
      { route: "cuisine-hierarchy", icon: "ft-arrow-right submenu-icon" },
      { route: "databasesource", icon: "ft-arrow-right submenu-icon" },
      { route: "datasource", icon: "ft-arrow-right submenu-icon" },
      { route: "dietarypreference", icon: "ft-arrow-right submenu-icon" },
      { route: "disease", icon: "ft-arrow-right submenu-icon" },
      { route: "diseasecategory", icon: "ft-arrow-right submenu-icon" },
      { route: "estore-category", icon: "ft-arrow-right submenu-icon" },
      { route: "finish-product-allergen", icon: "ft-arrow-right submenu-icon" },
      { route: "finish-product-observed-allergen", icon: "ft-arrow-right submenu-icon" },
      { route: "finish-product-observed-tolerance", icon: "ft-arrow-right submenu-icon" },
      { route: "flavour", icon: "ft-arrow-right submenu-icon" },
      { route: "foodgroup", icon: "ft-arrow-right submenu-icon" },
      { route: "foodgroupfao", icon: "ft-arrow-right submenu-icon" },
      { route: "fssai-category", icon: "ft-arrow-right submenu-icon" },
      { route: "healthcolorcode", icon: "ft-arrow-right submenu-icon" },
      { route: "ingredient-claims-master", icon: "ft-arrow-right submenu-icon" },
      { route: "ingredient-unit-of-measurement", icon: "ft-arrow-right submenu-icon" },
      { route: "intolerance", icon: "ft-arrow-right submenu-icon" },
      { route: "location", icon: "ft-arrow-right submenu-icon" },
      { route: "mealpreference", icon: "ft-arrow-right submenu-icon" },
      { route: "mealtype", icon: "ft-arrow-right submenu-icon" },
      { route: "nutrient", icon: "ft-arrow-right submenu-icon" },
      { route: "nutrientgroup", icon: "ft-arrow-right submenu-icon" },
      { route: "nutrienttag", icon: "ft-arrow-right submenu-icon" },
      { route: "ocassion", icon: "ft-arrow-right submenu-icon" },
      { route: "product-benefit-master", icon: "ft-arrow-right submenu-icon" },
      { route: "productform", icon: "ft-arrow-right submenu-icon" },
      { route: "reheatingmethod", icon: "ft-arrow-right submenu-icon" },
      { route: "rework-suggested-master", icon: "ft-arrow-right submenu-icon" },
      { route: "season", icon: "ft-arrow-right submenu-icon" },
      { route: "storagetype", icon: "ft-arrow-right submenu-icon" },
      { route: "supplement-category", icon: "ft-arrow-right submenu-icon" },
      { route: "supplement-claims-master", icon: "ft-arrow-right submenu-icon" },
      { route: "supplement-fssai-category", icon: "ft-arrow-right submenu-icon" },
      { route: "taste", icon: "ft-arrow-right submenu-icon" },
      { route: "texture", icon: "ft-arrow-right submenu-icon" },
      { route: "unit", icon: "ft-arrow-right submenu-icon" },
      { route: "unit-dosage-master", icon: "ft-arrow-right submenu-icon" },
      { route: "utensil", icon: "ft-arrow-right submenu-icon" }
    ]
  },

];
